






































































import { Component, Prop, Vue } from 'vue-property-decorator'
import AddItemModal from './AddItemModal.vue'
import { AppState } from '@/store'
import { CustomRouteConfig } from '@/types/router'
import Login from './Login.vue'
import packageJson from '../../../package.json'


@Component({
    components: {
        AddItemModal,
        Login
    }
})
export default class AppLayout extends Vue {
    @Prop() loading !: boolean
    addItemModal = false
    version = packageJson.version
    navDrawer = false

    get state(): AppState {
        return this.$store.state as AppState
    }

    get routes(): CustomRouteConfig[] {
        return this.$router.options.routes as CustomRouteConfig[]
    }

    get isLoggedIn(): boolean {
        return !!this.state.user
    }

    get updateAvailable(): boolean {
        return this.state.updateAvailable
    }

    openAddItemModal() {
        this.addItemModal = true
    }

    refreshPage() {
        this.$store.commit('updateAvailable', false)
        window.location.reload()
    }
}
